import React from 'react';
import CustomCardArticles from '../../CustomCardArticles';
import './homeArticles.css';

const HomeArticles = ({articles}) => {
  if (!articles || articles.length === 0) {
    return null;
  }

  return (
    <div className="wow fadeInUp" data-wow-delay="0.1s">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 animate-fade-in">
        {articles.map((article, index) => (
          <div 
            key={article.id}
            className="animate-fade-in-up"
            style={{
              animationDelay: `${index * 0.1}s`
            }}
          >
            <CustomCardArticles 
              title={article.title} 
              author={article.author} 
              id={article.id}
              photo={article.phote}
            />
          </div>
        ))}
      </div>

      {/* Empty State */}
      {articles.length === 0 && (
        <div className="text-center py-16">
          <div className="inline-block p-10 bg-gray-50 rounded-3xl">
            <svg className="w-20 h-20 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
            </svg>
            <h3 className="text-xl font-bold text-gray-700 mb-2">Aucun article disponible</h3>
            <p className="text-gray-500">Les articles seront bientôt disponibles</p>
          </div>
        </div>
      )}

      <style jsx>{`
        .animate-fade-in {
          animation: fadeIn 0.8s ease-out;
        }

        .animate-fade-in-up {
          animation: fadeInUp 0.6s ease-out forwards;
          opacity: 0;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default HomeArticles;